import { computed, type Computed } from 'ccstate'
import type { RoutePath } from './RoutePath'
import type { ReactNode } from 'react'
import { sharedLocationState } from '../../state/sharedLocationState'
import { match } from 'path-to-regexp'
import { logger } from '../../../common/infra/log'

const L = logger('routeRegistry')

// /projects/:id => { id: string }
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type ExtractParams<T extends string> = T extends `/${infer _Start}/:${infer Param}` ? Record<Param, string> : undefined

export const generateRouterPath = <T extends RoutePath>(path: T, pathParams?: ExtractParams<T>): string => {
  const routerPrefix = process.env.ROUTER_PREFIX ?? ''
  if (!pathParams || Object.keys(pathParams).length === 0) {
    return `${routerPrefix}${path}`
  }
  let _path = `${routerPrefix}${path}`
  for (const [key, value] of Object.entries(pathParams)) {
    _path = _path.replace(`:${key}`, value as string)
  }
  return _path
}

export interface RouteConfig {
    path: RoutePath
    onBeforeNavigate?: Computed<Promise<RoutePath | undefined>>
    viewFactory: () => ReactNode
}

const routeRegistry: RouteConfig[] = []

export const registerRoute = (config: RouteConfig) => {
  routeRegistry.push(config)
}

export const currentRoute$ = computed((get) => {
  const currentPath = get(sharedLocationState.pathname$)

  for (const config of routeRegistry) {
    const matcher = match(config.path, { decode: decodeURIComponent })
    const result = matcher(currentPath)
    if (result) {
      L.debug(L.fmt`hit path ${currentPath}`)
      return config
    }
  }
  L.debug(L.fmt`hit no path, registered paths: ${routeRegistry.map(config => config.path)}`)
  return null
})